import { PaletteOptions } from "@mui/material/styles";

export default {
  primary: {
    darker: "#FF7780",
    dark: "#C35058",
    main: "#35414d",
    light: "#202427",
    lighter: "#1a1b1c",
  },
  secondary: {
    dark: "#2BB4EF",
    main: "#35414d",
    light: "#202427",
    lighter: "#1a1b1c",
  },
  tertiary: {
    darker: "#8d8d8d",
    dark: "#3f3f3f",
    main: "#35414d",
    light: "#202427",
    lighter: "#1a1b1c",
    contrastText: "#fff",
  },
  shadow: {
    white: "#fff",
    black: "#000000",
    main: "#828282",
    light: "#212931",
    dark: "#4F4F4F",
    darker: "#333333",
    contrastText: "#fff",
  },
  text: {
    primary: "#FFFFFF",
    secondary: "#FFFFFF",
  },
  action: {
    active: "#B9DDED",
    asdfa: "#000",
  },
  background: {
    default: "#202427",
    paper: "#1a1b1c",
  },
  info: {
    dark: "#daf4ff",
    main: "#35414d",
    light: "#202427",
    lighter: "#1a1b1c",
  },
  warning: {
    darker: "#fff9da",
    dark: "#fff9da",
    main: "#614514",
    light: "#47320d",
    lighter: "#292010",
  },
  success: {
    darker: "#caf7cd",
    dark: "#caf7cd",
    main: "#1e4e39",
    light: "#24352d",
    lighter: "#212a26",
    contrastText: "#fff",
  },
  error: {
    dark: "#ffc1c6",
    main: "#FF7780",
    light: "#FF7780",
    lighter: "#C35058",
  },
} as PaletteOptions;
